import { render, staticRenderFns } from "./btsb-z.vue?vue&type=template&id=d77d45b0&scoped=true"
import script from "./btsb-z.vue?vue&type=script&lang=js"
export * from "./btsb-z.vue?vue&type=script&lang=js"
import style0 from "./btsb-z.vue?vue&type=style&index=0&id=d77d45b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77d45b0",
  null
  
)

export default component.exports